import React from 'react'
import {IonButton, IonButtons, IonIcon, IonItem, IonItemOptions, IonLabel} from "@ionic/react"
import {shieldCheckmarkOutline, shieldCheckmarkSharp} from "ionicons/icons"
import {useHistory} from "react-router"

import {LockType as ItemType} from "../../types/Lock"

import {useLockingSystems} from "../../contexts/LockingSystemContext";

import BadgeLockProgrammingState    from "../common/Badges/BadgeLockProgrammingState";
import IconLock                     from "../common/Icons/Lock";
import ListItemButtonLockTimeLimits from "./ListItems/ButtonLockTimeLimit";
import ListItemOptionDelete        from "./ListItemOptionDelete"

interface itemProps {
    item: ItemType
}

const ListItem: React.FC<itemProps> = ({ item }) => {
    const lockPermissionsCount: number = item.counts?.lockingSystemPermissions || 0;

    const history = useHistory()
    const {hasFeature: hasLockingSystemFeature} = useLockingSystems()

    const goToLockPermissions = (ev: any, itemId: number) => {
        ev.preventDefault()
        ev.stopPropagation()

        history.push('/locks/' + itemId + '/locking-system-permissions')
    }

    return (
        <>
            <IonItem button detail slot="start" routerLink={"/locks/" + item.id + '/view'}>
                <IconLock slot="start" />
                <IonLabel>
                    {item.lockingObject}
                    {item.locationCode &&
                    <span style={{ 'fontWeight': '200', 'fontSize': '0.8rem', 'paddingLeft': '0.4rem' }}>
                        - {item.locationCode}
                    </span>
                    }
                    {item.lockingSystemZone &&
                    <span style={{ 'fontWeight': '200', 'fontSize': '0.8rem', 'paddingLeft': '0.4rem' }}>
                        - {item.lockingSystemZone.name}
                    </span>
                    }
                    <p>
                        {item.lockType?.lockingSystemType?.brand?.name} - {item.lockType?.name}
                        {(item.serial && item.serial !== '0') &&
                        <span style={{ 'fontWeight': '200', 'fontSize': '0.8rem', 'paddingLeft': '0.4rem' }}>
                            ({item.serial})
                        </span>
                        }
                    </p>
                </IonLabel>
                {item.lockProgrammingState &&
                    <BadgeLockProgrammingState item={item.lockProgrammingState} />
                }
                <IonButtons className="ion-hide-sm-down" slot="end">
                    {hasLockingSystemFeature('HAS_TIME_LIMITS') === true &&
                    <span style={{ 'minWidth': '50px' }}>
                        <ListItemButtonLockTimeLimits lock={item} />
                    </span>
                    }
                    <div style={{ 'minWidth': '75px' }}>
                    <IonButton color={lockPermissionsCount ? "medium" : "light"} fill="clear"
                               onClick={ (ev) => goToLockPermissions(ev, item.id) }
                               shape="round" size="large" style={{ 'fontSize': '1rem' }}>
                        <IonIcon slot="start" ios={shieldCheckmarkOutline} md={shieldCheckmarkSharp} />
                        {lockPermissionsCount ? lockPermissionsCount : '-'}
                    </IonButton>
                    </div>
                </IonButtons>
            </IonItem>
            <IonItemOptions slot="end">
                <ListItemOptionDelete item={item} />
            </IonItemOptions>
        </>
    )
}

export default ListItem